/**
 * The failure vocabulary the flag services answer with.
 *
 * One enum holds the values; each operation exports a union of the members it can actually return,
 * so a caller still only handles what it can receive and `Record<TFailure, string>` still proves
 * every reason has a message. See `@/flags/constants/failure-messages`, where the same reason is
 * worded differently per operation — a failed write is "saving the flag" for one and "adding the
 * flags" for another, which is why the operations keep their own types rather than sharing one.
 */
export enum FlagFailure {
  /**
   * A read the operation depends on failed — the Flag Library Group, the library search, the entry,
   * or the chart. Retryable, and reported to Sentry at the point it happened.
   */
  LookupFailed = "lookup-failed",
  /** The practice has no Flag Library Group — onboarding or the backfill migration never ran. */
  MissingLibraryGroup = "missing-library-group",
  /**
   * The entry is not in this practice's active library: deleted while the drawer or the modal was
   * open, or an id from outside the library.
   */
  NotFound = "not-found",
  /** The name resolves to a code another active entry in this practice's library already holds. */
  DuplicateName = "duplicate-name",
  /** Medplum rejected a write. */
  WriteFailed = "write-failed",
  /** The Flag was written but could not be scoped to the practice compartment. */
  AccountsFailed = "accounts-failed",
  /**
   * The reader's access policy does not grant `Flag`. Roles that never see flags — doula, patient —
   * reach the chart legitimately, so this is a quiet "nothing to show" rather than a fault.
   */
  Forbidden = "forbidden",
}
